import { useGlobal } from "@/app/providers/use-global";
import { Check } from "lucide-react";

export const AutoScrollBack = () => {
  const { autoScrollBack, setAutoScrollBack } = useGlobal();

  const handleAutoScrollBack = () => {
    setAutoScrollBack(!autoScrollBack);
  };

  return (
    <button
      className="w-full text-sm flex items-center px-6 py-1.5 hover:bg-accent dark:hover:bg-neutral-700 rounded-sm"
      type="button"
      onClick={handleAutoScrollBack}
    >
      {autoScrollBack ? (
        <Check className="w-4 h-4 mr-2" />
      ) : (
        <div className="w-4 h-4 mr-2" />
      )}
      Auto Scroll-Back
    </button>
  );
};
